import {useNavigate} from 'react-router-dom'
import { type ScanResponse } from 'client/scanner/scanner.types'

interface Go {
  origin: ScanResponse
}

export const useGoToScanProductInContainer = () => {
  const navigate = useNavigate()

  return {
    go: ({ origin }: Go) => {
      const uri = SCAN_PRODUCT_IN_CONTAINER
        .replace(':location', origin.location?.name as string)
        .replace(':container', origin.container?.name || 'null')
      navigate(uri)
    }
  }
}

export const SCAN_PRODUCT_IN_CONTAINER = '/inventory-fix/:location/:container/product/scan'
